import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { EstadoSistemaService } from '../services/estado-sistema.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class RedInterceptor implements HttpInterceptor {

  constructor(
    private estadoSistemaService: EstadoSistemaService,
    private snackBar: MatSnackBar
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    return next.handle(request).pipe(
      // 1. ÉXITO: El sistema responde, todo está bien
      tap(() => {
        this.estadoSistemaService.reportarSistemaOperativo();
      }),
      
      // 2. ERROR: Analizamos qué tipo de caída es
      catchError((error: HttpErrorResponse) => {

        console.error('🚨 INTERCEPTOR: Error capturado!', error.status, error.message);

        // CASO A: CAÍDA REAL DEL SERVIDOR (Backend apagado o reiniciando)
        if (error.status >= 502 && error.status <= 504) {
          console.log('⚠️ Servidor caído. Activando Modal de Emergencia...');
          this.estadoSistemaService.reportarCaidaSistema();
        } 
        
        // CASO B: MICRO-CORTE DE INTERNET O PETICIÓN CANCELADA AL CAMBIAR DE PÁGINA
        else if (error.status === 0) {
          this.snackBar.open('Problema de conexión leve o petición interrumpida.', 'Cerrar', { 
            duration: 3000 
          });
        }
        
        // CASO C: ERROR DE CÓDIGO (Ej. Error 500 - Falla una consulta SQL o falta un dato)
        else if (error.status === 500) {
          this.snackBar.open('Error interno del sistema al procesar la solicitud.', 'Cerrar', { 
            duration: 5000,
            panelClass: ['error-snackbar'] // Asumiendo que tienes esta clase CSS global
          });
        }

        // Dejamos pasar el error para que el componente que hizo la llamada también se entere
        return throwError(() => error);
      })
    );
  }
}